/**
 * ReverseGeocodeUseCase
 * Layer: application (shared)
 * Change: manejo-de-coordenadas-y-mapas
 *
 * Translates GPS coordinates into a human-readable address via
 * GET /v3/generals/geocoding/reverse?latitude={lat}&longitude={lng}.
 *
 * Contract:
 * - Returns null immediately when lat === 0 && lng === 0 (null island guard)
 * - Returns null on any HTTP/network error — never throws to caller
 */
import { httpClient } from '@/shared/api/httpClient';

export interface ReverseGeocodeResult {
  formattedAddress: string;
  street?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  postalCode?: string | undefined;
}

interface ReverseGeocodeApiResponse {
  formatted_address?: string;
  street?: string;
  city?: string;
  state?: string;
  country?: string;
  postal_code?: string;
}

export async function reverseGeocodeUseCase(
  lat: number,
  lng: number,
): Promise<ReverseGeocodeResult | null> {
  // Null island guard — skip request when coords have no GPS fix
  if (lat === 0 && lng === 0) {
    return null;
  }

  try {
    const { data } = await httpClient.get<ReverseGeocodeApiResponse>(
      `/v3/generals/geocoding/reverse?latitude=${lat}&longitude=${lng}`,
    );

    return {
      formattedAddress: data.formatted_address ?? '',
      street: data.street,
      city: data.city,
      state: data.state,
      country: data.country,
      postalCode: data.postal_code,
    };
  } catch {
    return null;
  }
}
